export default "__VITE_ASSET__CaFTg_SB__"